import React from 'react';
import { X } from 'lucide-react';
import { EmailSendError } from '../services/feedbackInstanceService';

interface EmailErrorDetailsProps {
  errors: EmailSendError[];
  onClose: () => void;
}

const EmailErrorDetails: React.FC<EmailErrorDetailsProps> = ({ errors, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-lg max-h-[80vh] flex flex-col">
        <div className="p-4 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
            Failed Recipients ({errors.length})
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="overflow-y-auto flex-1 p-4">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                <th className="pb-2 font-medium">Email</th>
                <th className="pb-2 font-medium">Reason</th>
                <th className="pb-2 font-medium">Time</th>
              </tr>
            </thead>
            <tbody>
              {errors.map((error, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-100 dark:border-gray-700 last:border-0"
                >
                  <td className="py-2 text-gray-900 dark:text-white break-all pr-2">
                    {error.recipientEmail}
                  </td>
                  <td className="py-2 text-gray-600 dark:text-gray-400 pr-2">
                    {error.reason}
                  </td>
                  <td className="py-2 text-gray-500 dark:text-gray-500 whitespace-nowrap">
                    {error.attemptedAt ? new Date(error.attemptedAt).toLocaleString() : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="p-4 border-t border-gray-200 dark:border-gray-700">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-full hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailErrorDetails;
